import React from "react";
import {useDrop} from "react-dnd";

const ModeratorPlayerCardsContainer = props => {
    const [, drop] = useDrop(
        () => ({
            accept: "user-drop",
            drop: props.onDrop,
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop()
            })
        }),
        ['user-drop', props.onDrop]
    );

    return <div  ref={drop}>
        {props.children}
    </div>
}

export default ModeratorPlayerCardsContainer;
